import React from 'react';
import ToolSourceCard from './ToolSourceCard';
import ToolsFoundList from './ToolsFoundList';
import DiscoveryLinkField from './DiscoveryLinkField';
import ToolExecutionFields, { SWAGGER_EXECUTION_LABEL } from './ToolExecutionFields';
import { useSourceDiscovery } from './useSourceDiscovery';

const SWAGGER_LINK_HELP =
    'URL of a Swagger / OpenAPI document (JSON or YAML). Each operation becomes a tool under "Tools Selected".';
/** Figma 4012:18367 placeholder copy. */
export const SWAGGER_LINK_PLACEHOLDER = 'e.g. "url": "https://tools.companyname.ai/swagger"';

/**
 * "Swagger" card (Figma 4012:18367 / 4012:18823): Swagger Link (w-440) with
 * live discovery beside the "Tool Execution *" URL (w-400).
 */
const SwaggerToolSourceCard = ({ source, errors = {}, discovery, onChange, onRemove }) => {
    const { runDiscovery, toggleTool, setSelectedTools, loading, discoveryError } = useSourceDiscovery({
        source,
        discovery,
        onChange,
    });

    return (
        <ToolSourceCard type={source.type} onRemove={onRemove} className="cw-ac-source-card--swagger">
            <div className="cw-ac-swagger__row">
                <DiscoveryLinkField
                    label="Swagger Link"
                    helpText={SWAGGER_LINK_HELP}
                    placeholder={SWAGGER_LINK_PLACEHOLDER}
                    value={source.discovery_url}
                    onChange={(next) => onChange({ discovery_url: next })}
                    onDiscover={runDiscovery}
                    error={errors.discovery_url}
                    disabled={loading}
                    className="cw-ac-link-field--w440"
                />
                <ToolExecutionFields
                    label={SWAGGER_EXECUTION_LABEL}
                    url={source.execution_url}
                    onUrlChange={(next) => onChange({ execution_url: next })}
                    error={errors.execution_url}
                    className="cw-ac-execution--swagger"
                />
            </div>
            <ToolsFoundList
                tools={source.tools}
                selectedTools={source.selected_tools}
                onToggle={toggleTool}
                onSelectedChange={setSelectedTools}
                loading={loading}
                error={discoveryError || errors.tools}
            />
        </ToolSourceCard>
    );
};

export default SwaggerToolSourceCard;
